import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HStack } from "native-base";
import { useEffect, useState } from "react";
import { useFormContext } from "@madmedical/form";
import { useTranslation } from "@madmedical/i18n";
import Button from "../atoms/Button";
import Modal from "../molecules/Modal";
import ModalContent from "../molecules/ModalContent";
import SubmitButton from "../form/SubmitButton";
import DateTimeInput from "../form/DateTimeInput";
import FormTextAreaControl from "../form/FormTextAreaControl";
const AddCommentButtonMobile = ({ onSubmitPress, isSuccess }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const { setValue } = useFormContext();
    useEffect(() => {
        if (isSuccess) {
            setModalOpen(false);
        }
    }, [isSuccess]);
    useEffect(() => {
        if (isModalOpen) {
            setValue("date", new Date().toISOString());
        }
    }, [isModalOpen, setValue]);
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "outlined", leftIconName: "chat", width: "full", forceIcon: true, onPress: () => setModalOpen(true) }, { children: t("addComment") })), _jsx(Modal, Object.assign({ onClose: () => setModalOpen(false), open: isModalOpen }, { children: _jsxs(ModalContent, Object.assign({ header: t("addComment"), footer: _jsx(SubmitButton, { onPress: onSubmitPress, label: t("save"), width: "full" }) }, { children: [_jsx(HStack, Object.assign({ mb: 4 }, { children: _jsx(DateTimeInput, { name: "date", isRequired: true, label: t("appointment") }) })), _jsx(FormTextAreaControl, { name: "comment", isRequired: true, label: t("comment"), placeholder: t("addAComment") })] })) }))] }));
};
export default AddCommentButtonMobile;
